import * as actionTypes from './actionTypes';

/*------------------------------------------------------------------------------------------------*/
/* WorkflowWebhooks Fetch Actions                                                                             */
/*------------------------------------------------------------------------------------------------*/
/**
 * fetchWorkflowWebhooksRequest
 * Fetch workflowWebhooks request action.
 */
export const fetchWorkflowWebhooksRequest = () => ({
  type: actionTypes.FETCH_WORKFLOW_WEBHOOKS_REQUEST,
});

/**
 * createWorkflowWebhookRequest
 * Create workflowWebhook request action.
 */
export const createWorkflowWebhookRequest = (workflowWebhook, onSave) => ({
  type: actionTypes.CREATE_WORKFLOW_WEBHOOK_REQUEST,
  payload: { workflowWebhook, onSave },
});

/**
 * updateWorkflowWebhooksRequest
 * Update workflowWebhooks request action.
 */
export const updateWorkflowWebhookRequest = (workflowWebhook, onSave) => ({
  type: actionTypes.UPDATE_WORKFLOW_WEBHOOK_REQUEST,
  payload: { workflowWebhook, onSave },
});

/**
 * deleteWorkflowWebhooksRequest
 * Delete workflowWebhooks request action.
 */
export const deleteWorkflowWebhookRequest = (workflowWebhook, onDelete) => ({
  type: actionTypes.DELETE_WORKFLOW_WEBHOOK_REQUEST,
  payload: { workflowWebhook, onDelete },
});

/**
 * fetchWorkflowWebhooksError
 * Fetch workflowWebhooks request error action.
 * @param { String } error: The request error.
 */
export const fetchWorkflowWebhooksError = (error /*: string */) => ({
  type: actionTypes.FETCH_WORKFLOW_WEBHOOKS_ERROR,
  error,
});

/**
 * fetchWorkflowWebhooksResponse
 * Fetch workflowWebhooks response action.
 * @param { Object } response: The fetch response.
 */
export const fetchWorkflowWebhooksResponse = (workflowWebhooksList /*: [] */) => ({
  type: actionTypes.FETCH_WORKFLOW_WEBHOOKS_RESPONSE,
  workflowWebhooksList,
});

/**
 * updateWorkflowWebhookResponse
 * Update workflowWebhook response action.
 * @param { Object } workflowWebhook: The workflow webhook to update.
 */
export const updateWorkflowWebhookResponse = (workflowWebhook) => ({
  type: actionTypes.UPDATE_WORKFLOW_WEBHOOK_RESPONSE,
  payload: { workflowWebhook },
});

/**
 * updateWorkflowWebhookError
 * Update workflowWebhook error action.
 * @param { Object } error: The error message.
 */
export const updateWorkflowWebhookError = (error) => ({
  type: actionTypes.UPDATE_WORKFLOW_WEBHOOK_ERROR,
  error,
});

/**
 * createWorkflowWebhookError
 * Create workflowWebhooks error action.
 * @param { Object } error: The error message.
 */
export const createWorkflowWebhookError = (error) => ({
  type: actionTypes.CREATE_WORKFLOW_WEBHOOK_ERROR,
  error,
});

/**
 * deleteWorkflowWebhookError
 * Delete workflowWebhooks error action.
 * @param { Object } error: The error message.
 */
export const deleteWorkflowWebhookError = (error) => ({
  type: actionTypes.DELETE_WORKFLOW_WEBHOOK_ERROR,
  error,
});
